import { parseHubSource } from "src/utils/hubSource";

/**
 * EGD hub data source: `ers` (legacy) or `payload` (pg-payload-cms).
 * @returns {'ers' | 'payload'}
 */
export function getEgdSource() {
  return parseHubSource(process.env.REACT_APP_EGD_SOURCE);
}

export function isPayloadEgdSource() {
  return getEgdSource() === "payload";
}
